import { createStore } from 'vuex';
import notifications from './notifications';

export default createStore({
  modules: {
    notifications,
    // other modules...
  },
});